import { useState } from "react";
import { useNewsletterCommon } from "@companion-core/shared/app/Components/NewsletterModal/hooks/useNewsletterCommon";
import { useUpdateMember } from "@companion-core/shared/app/Queries";
import { useNewsletterStore } from "@companion-core/shared/app/Store/newsletterStore";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";

export const useNewsletterModal = () => {
  const { queryClient, newsletterModule, myAccountNewsletterModule, memberId } =
    useNewsletterCommon();
  const { setDismissDate, setIsOpen } = useNewsletterStore();
  const { mutateAsync: updateMember } = useUpdateMember();
  const [isUpdating, setIsUpdating] = useState(false);
  const optimizedUrl = getCloudinaryOptimizedUrl(newsletterModule.img, {
    width: 1200,
    contentType: "image",
  });

  const subscribe = async () => {
    try {
      setIsUpdating(true);
      await updateMember({
        id: "me",
        payload: {
          // eslint-disable-next-line camelcase
          marketing_email: "opt-in",
        },
      });
      await queryClient.invalidateQueries({ queryKey: ["member"] });
    } catch (e) {
    } finally {
      setIsOpen(false);
      setIsUpdating(false);
    }
  };

  const onClose = () => {
    setIsOpen(false);
    setDismissDate(new Date().getTime());
  };

  return {
    img: optimizedUrl,
    subscribe,
    onClose,
    isUpdating,
    myAccountNewsletterModule,
    memberId,
  };
};
